(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
  /**
   * Delegated from the document, not bound per button: the section replaces its
   * own markup after every add, so anything bound to the original nodes would
   * stop working on the second click.
   */
  (function () {
    const ADD_URL = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js';

    function sectionIdOf(selector) {
      const el = document.querySelector(selector);
      const wrapper = el && el.closest('.shopify-section');
      return wrapper ? wrapper.id.replace('shopify-section-', '') : null;
    }

    function swapSections(sections) {
      Object.keys(sections || {}).forEach((id) => {
        const current = document.getElementById('shopify-section-' + id);
        const markup = sections[id];
        if (!current || !markup) return;
        const parsed = new DOMParser().parseFromString(markup, 'text/html');
        const fresh = parsed.getElementById('shopify-section-' + id);
        if (fresh) current.replaceWith(fresh);
      });
    }

    function carriedProperties() {
      const node = document.querySelector('[data-carry-properties]');
      if (!node) return null;
      try {
        return JSON.parse(node.textContent);
      } catch (e) {
        return null;
      }
    }

    function setLabel(button, text) {
      const label = button.querySelector('.suggest__add-label');
      if (label) label.textContent = text;
    }

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-quick-add]');
      if (!button || button.getAttribute('aria-busy') === 'true') return;

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      setLabel(button, button.dataset.textAdding);

      const targets = [
        sectionIdOf('[data-suggest]'),
        sectionIdOf('.cart'),
        sectionIdOf('.nav'),
      ].filter(Boolean);

      try {
        const response = await fetch(ADD_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
                properties: carriedProperties() || {},
              },
            ],
            sections: targets.join(','),
            sections_url: window.location.pathname,
          }),
        });

        if (!response.ok) throw new Error('add failed');
        const data = await response.json();

        if (data.sections) {
          swapSections(data.sections);
          const status = document.querySelector('[data-suggest-status]');
          if (status) status.textContent = button.dataset.textAdd;
        } else {
          window.location.reload();
        }
      } catch (e) {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        setLabel(button, button.dataset.textAdd);
        const status = document.querySelector('[data-suggest-status]');
        if (status) {
          status.classList.remove('visually-hidden');
          status.textContent = button.dataset.textAdd;
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-card-form"] && !Shopify.designMode) return;
  try {
    
  /**
   * Two things the native form post leaves undone: the submit button gives no
   * sign the request started, and a server-side validation failure re-renders
   * the page with the error summary well above the fold but with focus back at
   * the top of the document.
   */
  (function () {
    var form = document.getElementById("custom-card-inquiry");
    if (!form) return;

    var errors = form.querySelector(".custom-card__errors");
    if (errors) {
      errors.setAttribute("tabindex", "-1");
      errors.focus({ preventScroll: true });
      errors.scrollIntoView({ block: "center" });
    }

    form.addEventListener("submit", function () {
      var button = form.querySelector("[data-inquiry-submit]");
      if (!button || button.getAttribute("aria-busy") === "true") return;

      // Left enabled so the button value still posts; the busy flag blocks the
      // double submit instead.
      button.setAttribute("aria-busy", "true");
      var label = button.querySelector("[data-inquiry-submit-label]");
      if (label) label.textContent = button.dataset.textSending;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * A native <details> is keyboard-openable but has no Escape behaviour of its
   * own, so an opened mobile menu trapped the reader until they tabbed back to
   * the summary and pressed Enter again. Escape closes it and returns focus to
   * the toggle, which is where a disclosure is expected to leave you.
   */
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const open = document.querySelector('.nav__disclosure[open]');
    if (!open) return;

    open.removeAttribute('open');
    const summary = open.querySelector('summary');
    if (summary) summary.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductGallery {
    constructor(root) {
      this.slides = Array.from(root.querySelectorAll('[data-media-slide]'));
      this.thumbs = Array.from(root.querySelectorAll('[data-media-thumb]'));

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this.select(Number(thumb.dataset.mediaThumb));
        });
      });
    }

    select(index) {
      this.slides.forEach((slide) => {
        slide.classList.toggle('is-active', Number(slide.dataset.mediaSlide) === index);
      });

      this.thumbs.forEach((thumb) => {
        const active = Number(thumb.dataset.mediaThumb) === index;
        thumb.classList.toggle('is-active', active);
        if (active) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }
  }

  class ProductForm {
    constructor(form) {
      this.form = form;
      this.root = form.closest('.shopify-section') || document;
      this.idInput = form.querySelector('[data-variant-id]');
      this.priceTargets = Array.from(this.root.querySelectorAll('[data-product-price]'));
      this.addButtons = Array.from(this.root.querySelectorAll('[data-add-button]'));

      const dataEl = this.root.querySelector('[data-product-variants]');
      try {
        this.variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        this.variants = [];
      }

      this.form.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-input]')) {
          this.onOptionChange();
        }
      });

      this.setupBuybar();
      this.setupVolume();
    }

    /**
     * Price breaks are shortcuts into the quantity field, not a second input.
     * Clicking one fills the field; typing a quantity by hand lights the
     * highest tier that quantity has reached, so the two always agree.
     */
    setupVolume() {
      const quantity = this.form.querySelector('[data-quantity-input]');
      const tiers = Array.from(this.root.querySelectorAll('[data-volume-tier]'));
      if (!quantity || !tiers.length) return;

      const sync = () => {
        const current = parseInt(quantity.value, 10) || 0;
        let best = null;
        tiers.forEach((tier) => {
          const min = parseInt(tier.dataset.quantity, 10);
          if (current >= min && (!best || min > parseInt(best.dataset.quantity, 10))) {
            best = tier;
          }
        });
        tiers.forEach((tier) => tier.classList.toggle('is-active', tier === best));
      };

      tiers.forEach((tier) => {
        tier.addEventListener('click', () => {
          quantity.value = tier.dataset.quantity;
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
          sync();
        });
      });

      quantity.addEventListener('input', sync);
      sync();
    }

    get selectedOptions() {
      const inputs = this.form.querySelectorAll('[data-option-input]:checked');
      return Array.from(inputs).map((input) => input.value);
    }

    onOptionChange() {
      const selected = this.selectedOptions;
      const match = this.variants.find((variant) =>
        variant.options.every((option, index) => option === selected[index])
      );

      if (!match) {
        this.setUnavailable();
        return;
      }

      this.idInput.value = match.id;
      this.priceTargets.forEach((target) => {
        target.textContent = match.price;
      });
      this.setAvailability(match.available);
    }

    setLabel(button, text) {
      const label = button.querySelector('[data-add-button-text]');
      if (label) label.textContent = text;
    }

    setAvailability(available) {
      this.addButtons.forEach((button) => {
        button.disabled = !available;
        this.setLabel(button, available ? button.dataset.textAdd : button.dataset.textSoldOut);
      });
    }

    setUnavailable() {
      this.addButtons.forEach((button) => {
        button.disabled = true;
        this.setLabel(button, button.dataset.textUnavailable);
      });
    }

    /**
     * The bar mirrors the real button rather than replacing it: it submits the
     * same form, and hands the reader back to the personalization field when
     * that field is required and still empty.
     */
    setupBuybar() {
      const bar = this.root.querySelector('[data-buybar]');
      const trigger = this.form.querySelector('[data-add-button]');
      if (!bar || !trigger) return;

      const barButton = bar.querySelector('[data-buybar-button]');
      if (barButton) {
        barButton.addEventListener('click', () => {
          if (!this.form.reportValidity()) {
            const invalid = this.form.querySelector(':invalid');
            if (invalid) invalid.focus();
            return;
          }
          this.form.requestSubmit();
        });
      }

      bar.hidden = false;

      if (!('IntersectionObserver' in window)) return;

      // No rootMargin: a negative bottom margin fired while the real button
      // was still fully on screen, so the page showed two competing
      // add-to-cart CTAs at once. The bar takes over only once the button has
      // actually left the viewport.
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            bar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { rootMargin: '0px', threshold: 0 }
      );

      observer.observe(trigger);
    }
  }

  function initProduct() {
    document.querySelectorAll('.product__media').forEach((media) => {
      if (media.dataset.initialized) return;
      media.dataset.initialized = 'true';
      new ProductGallery(media);
    });

    document.querySelectorAll('[data-product-form]').forEach((form) => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      new ProductForm(form);
    });
  }

  document.addEventListener('DOMContentLoaded', initProduct);
  document.addEventListener('shopify:section:load', initProduct);
  if (document.readyState !== 'loading') initProduct();

  } catch(e) { console.error(e); }
})();
})();
